import React from 'react';
import Aux from "../../../../../components/common/Aux";
import logo from '../../../../../assets/images/netmon-header.png';

const navLogo = (props) => {

  return (
    <Aux>
      <div className="navbar-brand header-logo">
        {props.collapseMenu ||
          <a href="https://netmon.com" className="b-brand" target="_blank" rel="noopener noreferrer"><img src={logo} alt="Logo" /></a>
        }
        <div className="mobile-menu" id="mobile-collapse" onClick={props.onToggleNavigation}>
          <i style={{ color: 'rgb(35, 183, 229)', cursor: 'pointer' }} className={`fa-solid fa-${props.collapseMenu ? 'bars' : 'xmark'} fa-lg`} />
        </div>
      </div>
    </Aux>
  );
};

export default navLogo;
